/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantRole } from './tenantRole';
import { AddressApiModel } from './addressApiModel';


export interface TenantDetailApiModel { 
    tenantId: number;
    tenantNumber: number;
    companyIco: string;
    companyDic: string;
    companyIcDPH: string;
    companyName: string;
    role: TenantRole;
    isActive: boolean;
    addressId: number;
    alias: string;
    roleId: number;
    billingEmails: Array<string>;
    address: AddressApiModel;
}
export namespace TenantDetailApiModel {
}


